<!-- step section -->

<section>
  <div class="page__title">
    <div class="page__title_container">
      <h2>
        {{ 'Additional_Parameters_Title' | translateWF: 'Additional Parameters' }}
      </h2>
      <div class="page__title_buttons">
        @if (canEdit) {
          <p-button [label]="'Additional_Parameters_Add' | translateWF: 'Add Parameter'" icon="pi pi-plus" [disabled]="!canEdit" (click)="addParameter()" />
        }
      </div>
    </div>
  </div>
  <form [formGroup]="formGroup">
    <p-table [value]="additionalParameters.controls" formArrayName="additionalParameters" cdkDropList (cdkDropListDropped)="canEdit ? drop($event) : null">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>{{ 'Additional_Parameters_Active' | translateWF: 'Active' }}</th>
          <th>
            {{ 'Additional_Parameters_Type' | translateWF: 'Parameter Type' }}
          </th>
          <th>
            {{ 'Additional_Parameters_Multiple' | translateWF: 'Multiple Values' }}
          </th>
          <th>
            {{ 'Additional_Parameters_Required' | translateWF: 'Required' }}
          </th>
          <th>
            {{ 'Additional_Parameters_Default' | translateWF: 'Default Values' }}
          </th>
          <th>{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-param let-i="rowIndex">
        <tr [formGroupName]="i" cdkDrag [cdkDragData]="param">
          <td>
            <span class="material-icons draggable">menu</span>
          </td>
          <td>
            <p-checkbox formControlName="isActive" [binary]="true" />
          </td>
          <td>
            <p-select appendTo="body" class="w-full" [options]="allParameters" optionLabel="name.en" optionValue="id" formControlName="parameterRef" />
          </td>
          <td>
            <p-checkbox formControlName="hasMultipleValues" [binary]="true" (ngModelChange)="resetParamValues(i)" />
          </td>
          <td>
            <p-checkbox formControlName="isRequired" [binary]="true" />
          </td>
          <td>
            <ng-container *ngIf="!param.controls.hasMultipleValues.value; else multipleValues">
              <div *ngIf="param && param.controls && param.controls.values && param.controls.values.controls[0]">
                <input type="text" [formControl]="param.controls.values.controls[0]" pInputText />
                <p *ngIf="param.controls.values.controls[0].errors" class="error">
                  {{ getParameterTypeErrorMessage(param.controls.values.controls[0]) }}
                </p>
              </div>
            </ng-container>
            <ng-template #multipleValues>
              <span class="readonly-field">
                {{ param.get('parameterNumber')?.value }}
              </span>
              <p-button
                [label]="'Additional_Parameters_Values' | translateWF: 'Values'"
                icon="pi pi-pencil"
                variant="outlined"
                [disabled]="!canEdit"
                (click)="openStepValuesModal(i)"
              />
            </ng-template>
          </td>
          <td>
            <p-button icon="pi pi-trash" (click)="removeParameter(i)" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </form>
</section>
